module.exports = __webpack_public_path__ + "img/2.cbe01482.png";